import * as React from 'react';
import { SVGProps } from 'react';
import { useTheme } from '@mui/material/styles';

const Logo = (props: SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    return (
        <svg width={135} height={42} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 337.4 191.5">
            <defs>
                <style>
                    {`
                .cls-1 { fill: #40af36; }
                .cls-2 { fill: #0081c9; }
                .cls-3 { fill: #e60012; }
                .cls-4 { fill: #231815; }
                .cls-5 { fill: #ed6a00; }
                .cls-6 { fill: #fbc400; }
                .cls-7 { fill: #b5589d; }
            `}
                </style>
            </defs>

            <g>
                <g id="_レイヤー_1" data-name="レイヤー_1">
                    <g>
                        <g>
                            <g>
                                <path
                                    className="cls-4"
                                    d="M30,33.7c3.6-.3,7.2-.4,11-.5,9,0,15.4.7,19,2.2,8.9,3.6,14.2,13.5,16.2,29.6,0,.6.1,1.3.1,2.1,0,4.9-1,10.6-3,17.3-2.2,7.2-4.8,12.1-7.6,14.4-4.1,3.4-13.3,5.2-27.6,5.3-2.3,0-4.4,0-6.2,0,0-6.3-.2-18.5-.6-36.6-.4-21.6-.8-32.8-1.2-33.7M43.5,50.8l1.3,35.7c5.5.3,12.2.3,12.2,0,0-3.5-.2-10.6-.8-36.3l-12.8.7Z"
                                />
                                <path
                                    className="cls-4"
                                    d="M88.7,39c4.1-3.9,9.7-5.9,16.7-6,4.1,0,7.5.8,10.4,2.6,4,2.6,6.8,6.6,8.4,12.2.8,4.1,1.6,8.2,2.4,12.3.4,1.9.7,4.9.8,9.2.2,13.6-1,22.2-3.7,26-2.3,3.2-4.4,5.3-6.2,6.5-2.4,1.6-5.4,2.4-9.2,2.5-8.8.2-14.9-1.7-18.5-5.7-5.3-5.7-8-13.6-8.2-23.6-.3-17.6,2.1-29.6,7.1-36M99.4,49.2l-.8,33.7c6-.7,12.9-.3,12.9-.5,0-.2-.7-10.1-2.6-34l-9.5.7Z"
                                />
                                <path
                                    className="cls-4"
                                    d="M158,31.9l8.4,28.9,10.5-26.8,12.3-.5c-6,14.6-13.5,25.7-18.3,35.1l.4,34.2h-18.6c0,0-.4-33.3-.4-33.3-2.4-4.7-9.7-17.1-16.7-37.3,6.2.5,13.7.4,22.5-.4"
                                />
                                <path
                                    className="cls-4"
                                    d="M231.7,74.4c-.4,10-3.4,17.8-8.8,23.4-3.7,3.8-9.9,5.6-18.7,5.2-3.7-.2-6.8-1.1-9.1-2.7-1.8-1.2-3.8-3.4-6-6.7-2.6-3.8-3.6-12.5-3-26.1.2-4.3.5-7.3,1-9.2.9-4,1.8-8.1,2.7-12.2,1.8-5.6,4.7-9.6,8.7-12,2.9-1.8,8.1-2.5,12.1-2.3,7,.3,10.8,2.4,14.9,6.4,4.9,6.5,7,18.6,6.2,36.2M204.5,50.6v32.6c5.9-.3,8.9-.5,9-.7,0-.2.6-9.7,3.2-31.3l-12.1-.5Z"
                                />
                                <path
                                    className="cls-4"
                                    d="M252.6,35.9c-.9,17.7-2.3,25-2.4,33.3-.1,4.8-.5,9.7-.3,10.2.8.6,2.8.9,6,.9,3.2,0,5.1-.4,5.6-1,.4-.3,1.2-6.7,1.3-14.8.1-5.7.2-13.2.2-22.3,0-9.2,0-13.2,0-12.1,0-.2,5.2-.3,15.7-.2-.1,29.4-.4,45.1-.8,47.1-.3,3-.7,6-1,9-.8,4.8-2.1,8.5-3.9,11-3,4-8,6.1-15.2,6.2-1.8,0-3.8,0-5.8-.3-3.6-.4-6.4-1.7-8.2-3.8-.6-.7-1.6-2.5-2.9-5.5-.7-1.5-1.2-6-1.5-13.4l-1.1-42.9,14.5-1.3Z"
                                />
                                <path
                                    className="cls-4"
                                    d="M286.3,99.3c-1.4-1.3-2.1-3.2-2.2-5.7-.2-4.2,1-6.7,3.5-7.7,2.5-.9,4.8-1.4,6.9-1.5,2.9-.1,5.2.6,6.9,2,1.7,1.5,2.6,3.4,2.7,5.9.1,2.8-.7,5.1-2.4,6.9-1.7,1.8-4.1,2.8-7.2,2.9-3.4.1-6.2-.8-8.2-2.8M289.2,78.9c-.2-3.8-1.1-10.9-1.4-22.1-.3-11.2-.8-19.7-1-24.4l22.4.8c-.2,3.9-1.5,11-3.8,21.3-2.6,11.8-4.3,21-4.9,25.4,0,.3-1.2-.9-11.3-1"
                                />
                            </g>
                            <g>
                                <path
                                    className="cls-3"
                                    d="M28.1,32.3c3.6-.3,7.2-.4,11-.5,9,0,15.4.7,19,2.2,8.9,3.6,14.2,13.5,16.2,29.6,0,.6.1,1.3.1,2.1,0,4.9-1,10.6-3,17.3-2.2,7.2-4.8,12.1-7.6,14.4-4.1,3.4-13.3,5.2-27.6,5.3-2.3,0-4.3,0-6.2,0,0-6.3-.2-18.5-.6-36.6-.4-21.6-.8-32.8-1.2-33.7M41.4,49.2l1.3,35.7c5.5.3,12.2.3,12.2,0,0-3.5-.2-10.6-.8-36.3l-12.8.7Z"
                                />
                                <path
                                    className="cls-5"
                                    d="M86.7,37.6c4.1-3.9,9.7-5.9,16.7-6,4.1,0,7.5.8,10.4,2.6,4,2.6,6.8,6.6,8.4,12.2.8,4.1,1.6,8.2,2.4,12.3.5,1.9.7,4.9.8,9.2.2,13.6-1,22.2-3.7,26-2.3,3.2-4.4,5.3-6.2,6.5-2.4,1.6-5.4,2.4-9.2,2.5-8.8.2-14.9-1.7-18.5-5.7-5.3-5.7-8-13.6-8.2-23.6-.3-17.6,2-29.6,7.1-36M97.2,47.6l-.8,33.7c6-.7,12.9-.3,12.9-.5,0-.2-.7-10.1-2.6-34l-9.5.7Z"
                                />
                                <path
                                    className="cls-6"
                                    d="M155.7,30.3l8.4,28.9,10.5-26.8,12.3-.5c-6,14.6-13.5,25.7-18.3,35.1l.4,34.2h-18.6c0,0-.4-33.3-.4-33.3-2.4-4.7-9.7-17.1-16.7-37.3,6.2.5,13.7.4,22.5-.4"
                                />
                                <path
                                    className="cls-1"
                                    d="M229.5,72.7c-.4,10-3.4,17.8-8.8,23.4-3.7,3.8-9.9,5.6-18.7,5.2-3.7-.2-6.8-1.1-9.1-2.7-1.8-1.2-3.8-3.4-6-6.7-2.6-3.8-3.6-12.5-3-26.1.2-4.3.5-7.3,1-9.2.9-4,1.8-8.1,2.7-12.2,1.8-5.6,4.7-9.6,8.7-12,2.9-1.8,8.1-2.5,12.1-2.3,7,.3,10.8,2.4,14.9,6.4,4.9,6.5,7,18.6,6.2,36.2M202.4,48.9v32.6c5.9-.3,9-.5,9-.7,0-.2.6-9.7,3.2-31.3l-12.1-.5Z"
                                />
                                <path
                                    className="cls-2"
                                    d="M250.4,34.2c-.9,17.7-2.3,25-2.5,33.3-.1,4.8-.5,9.7-.3,10.2.8.6,2.7.9,6,.9,3.2,0,5.1-.4,5.6-1,.4-.3,1.2-6.7,1.3-14.8.1-5.7.2-13.2.2-22.3,0-9.2,0-13.2,0-12.1,0-.2,5.2-.3,15.7-.2-.1,29.4-.4,45.1-.8,47.1-.3,3-.7,6-1,9-.8,4.8-2.1,8.5-3.9,11-3,4-8,6.1-15.2,6.2-1.8,0-3.8,0-5.8-.3-3.6-.4-6.4-1.7-8.2-3.8-.6-.7-1.6-2.5-2.9-5.5-.7-1.5-1.2-6-1.5-13.4l-1.1-42.9,14.5-1.3Z"
                                />
                                <path
                                    className="cls-7"
                                    d="M283.9,97.8c-1.4-1.3-2.1-3.2-2.2-5.7-.2-4.2,1-6.7,3.5-7.7,2.5-.9,4.8-1.4,6.9-1.5,2.9-.1,5.2.6,6.9,2,1.7,1.5,2.6,3.4,2.7,5.9.1,2.8-.7,5.1-2.4,6.9-1.7,1.8-4.1,2.8-7.2,2.9-3.4.1-6.2-.8-8.2-2.8M286.9,77.4c-.2-3.8-1.1-10.9-1.4-22.1-.3-11.2-.8-19.7-1-24.4l22.4.8c-.2,3.9-1.5,11-3.8,21.3-2.6,11.8-4.3,21-4.9,25.4,0,.3-1.2-.9-11.3-1"
                                />
                            </g>
                        </g>
                        <g>
                            <rect className="cls-4" x="102.8" y="120.4" width="18.4" height="10.7" />
                            <polygon
                                className="cls-4"
                                points="242.8 163.4 225.5 140 225.5 140 241.2 116.7 199.9 116.7 199.9 127.4 221.5 127.4 197.4 163.4 209.9 163.4 219.6 148.9 230.3 163.4 242.8 163.4"
                            />
                            <g>
                                <rect className="cls-4" x="155.6" y="116.7" width="36.4" height="10.7" />
                                <polygon
                                    className="cls-4"
                                    points="194.4 132.8 151.5 132.8 151.5 143.5 167.6 143.5 158 163.4 170.5 163.4 180.1 143.5 194.4 143.5 194.4 132.8"
                                />
                            </g>
                            <polygon
                                className="cls-4"
                                points="282.4 140.2 258.1 134 258.1 116.7 247.4 116.7 247.4 163.4 258.1 163.4 258.1 144.7 282.4 150.8 282.4 140.2"
                            />
                            <polygon
                                className="cls-4"
                                points="84.5 116.7 54.9 116.7 54.9 127.4 84.5 127.4 84.5 152.7 54.9 152.7 54.9 163.4 84.5 163.4 95.2 163.4 95.2 152.7 95.2 127.4 95.2 116.7 84.5 116.7"
                            />
                            <polygon
                                className="cls-4"
                                points="136.2 116.7 122.4 152.7 104 152.7 104 163.4 118.3 163.4 127.5 163.4 130.7 163.4 148.7 116.7 136.2 116.7"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Logo;
